<form class="rb-shell" [formGroup]="form" (ngSubmit)="generate()">
  <header class="rb-header">
    <div class="rb-title">
      <i class="fa-solid fa-file-lines"></i>
      <span>Resume Builder</span>
    </div>

    <div class="rb-actions">
      <button type="button" class="btn ghost" (click)="clear()" [disabled]="isLoading">
        Clear
      </button>

      <button
        type="submit"
        class="btn primary"
        [disabled]="!canGenerate"
      >
        <span *ngIf="!isLoading">Generate</span>
        <span *ngIf="isLoading">Generating…</span>
      </button>
    </div>
  </header>

  <div class="rb-grid">
    <section class="rb-card">
      <h3>Current resume</h3>

      <textarea
        rows="14"
        formControlName="currentResume"
        [class.invalid]="form.get('currentResume')?.touched && form.get('currentResume')?.invalid"
        placeholder="Paste your current resume text here…"
      ></textarea>

      <p class="hint" *ngIf="form.get('currentResume')?.touched && form.get('currentResume')?.invalid">
        Please paste at least ~30 characters of resume text.
      </p>
    </section>

    <section class="rb-card">
      <h3>Job description</h3>

      <textarea
        rows="14"
        formControlName="jobDescription"
        [class.invalid]="form.get('jobDescription')?.touched && form.get('jobDescription')?.invalid"
        placeholder="Paste the job description here…"
      ></textarea>

      <p class="hint" *ngIf="form.get('jobDescription')?.touched && form.get('jobDescription')?.invalid">
        Please paste at least ~30 characters of job description text.
      </p>
    </section>
  </div>

  <section class="rb-output">
    <div class="rb-output-header">
      <h3>Generated resume</h3>

      <button type="button" class="btn ghost" (click)="copyOutput()" [disabled]="!generatedResume">
        <i class="fa-regular fa-copy"></i>
        Copy
      </button>
    </div>

    <div class="rb-error" *ngIf="error">
      <i class="fa-solid fa-triangle-exclamation"></i>
      <span>{{ error }}</span>
    </div>

    <pre class="rb-output-box" *ngIf="generatedResume">{{ generatedResume }}</pre>

    <div class="rb-empty" *ngIf="!generatedResume && !error">
      Paste your resume + job description, then click <strong>Generate</strong>.
    </div>
  </section>
</form>
